import React from "react";

export interface ICheckboxProps {
  name: string,
  checked: boolean,
  onChange: (e: any) => void,
  label: string,
  key?: number
}

export default ({ label = "", name, checked = false, onChange, key = 1 }: ICheckboxProps) => {
    return (
        <label key={key} >
            <input type="checkbox" name={name} checked={checked} onChange={onChange} className="mr-3" />
            {label}
        </label>
    );
};